import { HStack } from '@chakra-ui/react';
import { BedrockColors } from 'chakra-ui/bedrockTheme';
import { OpenbookStatusEnum } from '.';
import FilterButton from './FilterButton';

const BookFilters = ({ bookData, selectedStatus, setPage, setSelectedStatus }) => {
  const filters = [
    {
      label: 'Active Clients',
      value: bookData?.numActive,
      status: OpenbookStatusEnum.ACTIVE,
      tooltip: 'Clients with an active plan of any type.',
    },
    {
      label: 'Inactive Clients',
      value: bookData?.numInactive,
      status: OpenbookStatusEnum.INACTIVE,
      tooltip: 'Clients with an inactive plan of some plan type for which they have no active or future active plan.',
    },
    {
      label: 'Future Active Clients',
      value: bookData?.numFuture,
      status: OpenbookStatusEnum.FUTURE_ACTIVE,
      tooltip: 'Clients with a future active plan of some plan type for which they have no active plan.',
    },
  ];

  return (
    <HStack gap={16} color={BedrockColors.primary}>
      <HStack spacing={6}>
        {filters.map((filter) => (
          <FilterButton
            key={filter.label}
            selectedStatus={selectedStatus}
            setPage={setPage}
            setSelectedStatus={setSelectedStatus}
            {...filter}
          />
        ))}
      </HStack>
    </HStack>
  );
};

export default BookFilters;
